import {Property} from "csstype";
import {FunnelKey, ContentKeyPair, ContentKey} from "./Keys";
import {CellContent, EditorType} from "./CellContent";
import {HiddenBy} from "./CJmapManager";
import {ClipboardCell} from "./ClipboardCell";
import {CellSize} from "./CellSize";

type ContentCellState = {
    IsSelected: boolean;
    IsEdit: boolean;
    HiddenBy: HiddenBy;
    Width: number;
    Height: number;
    EditorType: EditorType;
    ActionLineColor: Property.Color;

    LeftCellKeyPairOrNull: ContentKeyPair | null;
    RightCellKeyPairOrNull: ContentKeyPair | null;
    UpCellKeyPairOrNull: ContentKeyPair | null;
    DownCellKeyPairOrNull: ContentKeyPair | null;

    Collaborators: string[];
}

export class ContentCell {
    private readonly key_pair: ContentKeyPair;
    public data: CellContent;
    private readonly state: ContentCellState;

    constructor(key_pair: ContentKeyPair, data: CellContent, state: ContentCellState) {
        this.key_pair = key_pair;
        this.data = data;
        this.state = state;
    }

    get ContentKey(): ContentKey {
        return this.key_pair.LineKey;
    }

    get FunnelKey(): FunnelKey {
        return this.key_pair.FunnelKey;
    }

    get KeyPair(): ContentKeyPair {
        return this.key_pair;
    }

    get State(): ContentCellState {
        return Object.assign(this.state);
    }

    toClipboardData(): ClipboardCell {
        return new ClipboardCell(
            this.KeyPair,
            new CellSize(this.state.Width, this.state.Height),
            this.data
        );
    }


    toJSON() {
        throw new Error("not implemented");
        // return {
        //     key_pair: this.key_pair,
        //     data: this.data.toJSON(),
        // };
    }

    static fromJSON(json: any) {
        throw new Error("not implemented");
        // return new ContentCell(
        //     ContentKeyPair.fromJSON(json.key_pair),
        //     CellContent.fromJSON(json.data)
        // );
    }
}

export class ContentCells {
    private readonly content_cells: ContentCell[];

    constructor(content_cells: ContentCell[]) {
        this.content_cells = content_cells;
    }

    map<U>(callbackfn: (content_cell: ContentCell, index: number, array: ContentCell[]) => U): U[] {
        return this.content_cells.map(callbackfn);
    }

    getSelectedCellOrNull(): ContentCell | null {
        const cell = this.content_cells.find(c => c.State.IsSelected);
        return cell ?? null;
    }
}
